@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(2_076_309_025)
public val Res.string.bulk_edit_selected: StringResource by lazy {
      StringResource("string:bulk_edit_selected", "bulk_edit_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46557, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64677, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40220, 46),
      ))
    }

@delegate:ResourceContentHash(-1_207_920_499)
public val Res.string.bulk_edit_title: StringResource by lazy {
      StringResource("string:bulk_edit_title", "bulk_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46612, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64756, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40267, 59),
      ))
    }

@delegate:ResourceContentHash(137_123_082)
public val Res.string.bulk_edit_undone: StringResource by lazy {
      StringResource("string:bulk_edit_undone", "bulk_edit_undone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46668, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64836, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40327, 56),
      ))
    }

@delegate:ResourceContentHash(-1_907_865_506)
public val Res.string.bulk_effective_from: StringResource by lazy {
      StringResource("string:bulk_effective_from", "bulk_effective_from", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46717, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64901, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40384, 43),
      ))
    }

@delegate:ResourceContentHash(-756_974_101)
public val Res.string.bulk_effective_hint: StringResource by lazy {
      StringResource("string:bulk_effective_hint", "bulk_effective_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 46765, 243),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 64941, 347),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40428, 179),
      ))
    }

@delegate:ResourceContentHash(1_895_986_842)
public val Res.string.bulk_end_on: StringResource by lazy {
      StringResource("string:bulk_end_on", "bulk_end_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47009, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65289, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40608, 31),
      ))
    }

@delegate:ResourceContentHash(-811_018_599)
public val Res.string.bulk_field_contract: StringResource by lazy {
      StringResource("string:bulk_field_contract", "bulk_field_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47049, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65345, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40640, 39),
      ))
    }

@delegate:ResourceContentHash(-1_939_660_226)
public val Res.string.bulk_field_end: StringResource by lazy {
      StringResource("string:bulk_field_end", "bulk_field_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47085, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65393, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40680, 46),
      ))
    }

@delegate:ResourceContentHash(1_283_924_846)
public val Res.string.bulk_field_pay: StringResource by lazy {
      StringResource("string:bulk_field_pay", "bulk_field_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47144, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65468, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40727, 34),
      ))
    }

@delegate:ResourceContentHash(717_074_590)
public val Res.string.bulk_field_role: StringResource by lazy {
      StringResource("string:bulk_field_role", "bulk_field_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47179, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65535, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40762, 35),
      ))
    }

@delegate:ResourceContentHash(-1_791_205_785)
public val Res.string.bulk_field_skills: StringResource by lazy {
      StringResource("string:bulk_field_skills", "bulk_field_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47219, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65575, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40798, 33),
      ))
    }

@delegate:ResourceContentHash(-303_299_389)
public val Res.string.bulk_finances_only: StringResource by lazy {
      StringResource("string:bulk_finances_only", "bulk_finances_only", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47265, 178),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65621, 246),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40832, 166),
      ))
    }

@delegate:ResourceContentHash(953_296_668)
public val Res.string.bulk_hours_value: StringResource by lazy {
      StringResource("string:bulk_hours_value", "bulk_hours_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47444, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65868, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40999, 44),
      ))
    }

@delegate:ResourceContentHash(-1_167_761_047)
public val Res.string.bulk_none: StringResource by lazy {
      StringResource("string:bulk_none", "bulk_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47501, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65937, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41044, 25),
      ))
    }

@delegate:ResourceContentHash(1_619_496_526)
public val Res.string.bulk_pay_amount: StringResource by lazy {
      StringResource("string:bulk_pay_amount", "bulk_pay_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47527, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 65971, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41070, 35),
      ))
    }

@delegate:ResourceContentHash(-196_510_180)
public val Res.string.bulk_pay_hourly: StringResource by lazy {
      StringResource("string:bulk_pay_hourly", "bulk_pay_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47563, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66011, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41106, 39),
      ))
    }

@delegate:ResourceContentHash(-2_058_132_335)
public val Res.string.bulk_pay_monthly: StringResource by lazy {
      StringResource("string:bulk_pay_monthly", "bulk_pay_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47611, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66067, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41146, 40),
      ))
    }

@delegate:ResourceContentHash(-1_402_446_511)
public val Res.string.bulk_pay_percent: StringResource by lazy {
      StringResource("string:bulk_pay_percent", "bulk_pay_percent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47660, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66124, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41187, 40),
      ))
    }

@delegate:ResourceContentHash(1_912_538_837)
public val Res.string.bulk_pay_value: StringResource by lazy {
      StringResource("string:bulk_pay_value", "bulk_pay_value", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47853, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66377, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41352, 34),
      ))
    }

@delegate:ResourceContentHash(-1_569_814_414)
public val Res.string.bulk_pay_value_hint: StringResource by lazy {
      StringResource("string:bulk_pay_value_hint", "bulk_pay_value_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47701, 151),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66177, 199),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41228, 123),
      ))
    }

@delegate:ResourceContentHash(-2_076_276_756)
public val Res.string.bulk_problem_contract: StringResource by lazy {
      StringResource("string:bulk_problem_contract", "bulk_problem_contract", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47892, 105),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66436, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41387, 101),
      ))
    }

@delegate:ResourceContentHash(-1_184_104_106)
public val Res.string.bulk_problem_date: StringResource by lazy {
      StringResource("string:bulk_problem_date", "bulk_problem_date", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 47998, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66606, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41489, 45),
      ))
    }

@delegate:ResourceContentHash(-1_562_891_399)
public val Res.string.bulk_problem_nothing: StringResource by lazy {
      StringResource("string:bulk_problem_nothing", "bulk_problem_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48044, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66664, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41535, 68),
      ))
    }

@delegate:ResourceContentHash(-445_920_906)
public val Res.string.bulk_problem_pay: StringResource by lazy {
      StringResource("string:bulk_problem_pay", "bulk_problem_pay", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48117, 112),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66769, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41604, 100),
      ))
    }

@delegate:ResourceContentHash(-2_027_403_432)
public val Res.string.bulk_problem_role: StringResource by lazy {
      StringResource("string:bulk_problem_role", "bulk_problem_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48230, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66930, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41705, 53),
      ))
    }

@delegate:ResourceContentHash(-359_297_109)
public val Res.string.bulk_problem_skills: StringResource by lazy {
      StringResource("string:bulk_problem_skills", "bulk_problem_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48280, 95),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 66996, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41759, 71),
      ))
    }

@delegate:ResourceContentHash(-383_362_951)
public val Res.string.bulk_save: StringResource by lazy {
      StringResource("string:bulk_save", "bulk_save", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48376, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67128, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41831, 33),
      ))
    }

@delegate:ResourceContentHash(1_440_116_499)
public val Res.string.bulk_scope_group: StringResource by lazy {
      StringResource("string:bulk_scope_group", "bulk_scope_group", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48414, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67182, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41865, 48),
      ))
    }

@delegate:ResourceContentHash(-1_066_134_395)
public val Res.string.bulk_scope_workplace: StringResource by lazy {
      StringResource("string:bulk_scope_workplace", "bulk_scope_workplace", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48463, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67239, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41914, 48),
      ))
    }

@delegate:ResourceContentHash(327_827_268)
public val Res.string.bulk_select: StringResource by lazy {
      StringResource("string:bulk_select", "bulk_select", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48846, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67762, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42269, 27),
      ))
    }

@delegate:ResourceContentHash(-719_852_141)
public val Res.string.bulk_select_all: StringResource by lazy {
      StringResource("string:bulk_select_all", "bulk_select_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48504, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67296, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41963, 39),
      ))
    }

@delegate:ResourceContentHash(1_586_230_864)
public val Res.string.bulk_select_hint: StringResource by lazy {
      StringResource("string:bulk_select_hint", "bulk_select_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48552, 172),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67352, 256),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42003, 144),
      ))
    }

@delegate:ResourceContentHash(-1_390_495_902)
public val Res.string.bulk_select_stop: StringResource by lazy {
      StringResource("string:bulk_select_stop", "bulk_select_stop", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48725, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67609, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42148, 48),
      ))
    }

@delegate:ResourceContentHash(-558_767_732)
public val Res.string.bulk_selected_count: StringResource by lazy {
      StringResource("string:bulk_selected_count", "bulk_selected_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48774, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67674, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42197, 71),
      ))
    }

@delegate:ResourceContentHash(138_245_921)
public val Res.string.bulk_show_summary: StringResource by lazy {
      StringResource("string:bulk_show_summary", "bulk_show_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48878, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67802, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42297, 45),
      ))
    }

@delegate:ResourceContentHash(-180_790_072)
public val Res.string.bulk_skills_add: StringResource by lazy {
      StringResource("string:bulk_skills_add", "bulk_skills_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48932, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67872, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42343, 27),
      ))
    }

@delegate:ResourceContentHash(1_704_073_326)
public val Res.string.bulk_skills_remove: StringResource by lazy {
      StringResource("string:bulk_skills_remove", "bulk_skills_remove", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48964, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67912, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42371, 34),
      ))
    }

@delegate:ResourceContentHash(-1_007_040_583)
public val Res.string.bulk_skip_already_ended: StringResource by lazy {
      StringResource("string:bulk_skip_already_ended", "bulk_skip_already_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 48999, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 67963, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42406, 59),
      ))
    }

@delegate:ResourceContentHash(1_012_705_556)
public val Res.string.bulk_skip_before_start: StringResource by lazy {
      StringResource("string:bulk_skip_before_start", "bulk_skip_before_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49059, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68039, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42466, 86),
      ))
    }

@delegate:ResourceContentHash(-382_458_771)
public val Res.string.bulk_skip_line: StringResource by lazy {
      StringResource("string:bulk_skip_line", "bulk_skip_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49154, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68158, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42553, 50),
      ))
    }

@delegate:ResourceContentHash(294_776_371)
public val Res.string.bulk_skip_month_closed: StringResource by lazy {
      StringResource("string:bulk_skip_month_closed", "bulk_skip_month_closed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49205, 130),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68217, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42604, 98),
      ))
    }

@delegate:ResourceContentHash(895_706_367)
public val Res.string.bulk_skip_no_change: StringResource by lazy {
      StringResource("string:bulk_skip_no_change", "bulk_skip_no_change", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49336, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68392, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42703, 51),
      ))
    }

@delegate:ResourceContentHash(812_144_445)
public val Res.string.bulk_skip_no_pay_terms: StringResource by lazy {
      StringResource("string:bulk_skip_no_pay_terms", "bulk_skip_no_pay_terms", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49384, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68444, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42755, 70),
      ))
    }

@delegate:ResourceContentHash(-1_358_748_531)
public val Res.string.bulk_skip_not_allowed: StringResource by lazy {
      StringResource("string:bulk_skip_not_allowed", "bulk_skip_not_allowed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49471, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68559, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42826, 81),
      ))
    }

@delegate:ResourceContentHash(-1_015_437_369)
public val Res.string.bulk_summary_count: StringResource by lazy {
      StringResource("string:bulk_summary_count", "bulk_summary_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49553, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68689, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42908, 66),
      ))
    }

@delegate:ResourceContentHash(1_238_553_251)
public val Res.string.bulk_summary_nothing: StringResource by lazy {
      StringResource("string:bulk_summary_nothing", "bulk_summary_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49616, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68768, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 42975, 84),
      ))
    }

@delegate:ResourceContentHash(799_853_751)
public val Res.string.bulk_summary_title: StringResource by lazy {
      StringResource("string:bulk_summary_title", "bulk_summary_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49697, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68893, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43060, 50),
      ))
    }

@delegate:ResourceContentHash(1_422_880_375)
public val Res.string.bulk_undo: StringResource by lazy {
      StringResource("string:bulk_undo", "bulk_undo", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49748, 25),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68956, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43111, 25),
      ))
    }

@delegate:ResourceContentHash(261_822_730)
public val Res.string.business_month_note: StringResource by lazy {
      StringResource("string:business_month_note", "business_month_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49774, 159),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 68998, 271),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43137, 155),
      ))
    }

@delegate:ResourceContentHash(-1_817_406_832)
public val Res.string.business_month_shared: StringResource by lazy {
      StringResource("string:business_month_shared", "business_month_shared", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49934, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 69270, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43293, 57),
      ))
    }

@delegate:ResourceContentHash(1_943_130_474)
public val Res.string.business_month_title: StringResource by lazy {
      StringResource("string:business_month_title", "business_month_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 49992, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 69352, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43351, 68),
      ))
    }

@delegate:ResourceContentHash(-1_633_715_456)
public val Res.string.busy_elsewhere_other_employer: StringResource by lazy {
      StringResource("string:busy_elsewhere_other_employer", "busy_elsewhere_other_employer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50057, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 69445, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43420, 69),
      ))
    }

@delegate:ResourceContentHash(1_957_213_443)
public val Res.string.busy_elsewhere_rest_note: StringResource by lazy {
      StringResource("string:busy_elsewhere_rest_note", "busy_elsewhere_rest_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50131, 228),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 69555, 376),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43490, 212),
      ))
    }

@delegate:ResourceContentHash(-461_228_804)
public val Res.string.busy_elsewhere_same_owner: StringResource by lazy {
      StringResource("string:busy_elsewhere_same_owner", "busy_elsewhere_same_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50360, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 69932, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43703, 69),
      ))
    }

@delegate:ResourceContentHash(1_216_819_659)
public val Res.string.calendar_app_apple: StringResource by lazy {
      StringResource("string:calendar_app_apple", "calendar_app_apple", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50534, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70170, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43881, 46),
      ))
    }

@delegate:ResourceContentHash(1_431_918_981)
public val Res.string.calendar_app_apple_hint: StringResource by lazy {
      StringResource("string:calendar_app_apple_hint", "calendar_app_apple_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50426, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70026, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43773, 107),
      ))
    }

@delegate:ResourceContentHash(30_754_301)
public val Res.string.calendar_app_google: StringResource by lazy {
      StringResource("string:calendar_app_google", "calendar_app_google", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50754, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70490, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44089, 47),
      ))
    }

@delegate:ResourceContentHash(-1_184_976_327)
public val Res.string.calendar_app_google_hint: StringResource by lazy {
      StringResource("string:calendar_app_google_hint", "calendar_app_google_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50581, 172),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70229, 260),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43928, 160),
      ))
    }

@delegate:ResourceContentHash(-1_625_225_807)
public val Res.string.calendar_app_outlook: StringResource by lazy {
      StringResource("string:calendar_app_outlook", "calendar_app_outlook", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51037, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70905, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44364, 40),
      ))
    }

@delegate:ResourceContentHash(-463_334_665)
public val Res.string.calendar_app_outlook_hint: StringResource by lazy {
      StringResource("string:calendar_app_outlook_hint", "calendar_app_outlook_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50806, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70550, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44137, 77),
      ))
    }

@delegate:ResourceContentHash(-749_092_268)
public val Res.string.calendar_app_outlook_work: StringResource by lazy {
      StringResource("string:calendar_app_outlook_work", "calendar_app_outlook_work", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50967, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70799, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44298, 65),
      ))
    }

@delegate:ResourceContentHash(-1_755_961_363)
public val Res.string.calendar_app_outlook_work_hint: StringResource by lazy {
      StringResource("string:calendar_app_outlook_work_hint", "calendar_app_outlook_work_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 50880, 86),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70656, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44215, 82),
      ))
    }

@delegate:ResourceContentHash(-1_743_574_756)
public val Res.string.calendar_link_copied: StringResource by lazy {
      StringResource("string:calendar_link_copied", "calendar_link_copied", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51078, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 70946, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44405, 44),
      ))
    }

@delegate:ResourceContentHash(564_811_168)
public val Res.string.calendar_link_copy: StringResource by lazy {
      StringResource("string:calendar_link_copy", "calendar_link_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51127, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 71031, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44450, 38),
      ))
    }

@delegate:ResourceContentHash(-1_614_155_526)
public val Res.string.calendar_link_new: StringResource by lazy {
      StringResource("string:calendar_link_new", "calendar_link_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51170, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 71110, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44489, 49),
      ))
    }

@delegate:ResourceContentHash(659_589_660)
public val Res.string.calendar_link_off: StringResource by lazy {
      StringResource("string:calendar_link_off", "calendar_link_off", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51220, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 71196, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44539, 49),
      ))
    }

@delegate:ResourceContentHash(-995_046_342)
public val Res.string.calendar_sub_copy_hint: StringResource by lazy {
      StringResource("string:calendar_sub_copy_hint", "calendar_sub_copy_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51266, 190),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 71270, 346),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44589, 190),
      ))
    }

@delegate:ResourceContentHash(2_106_344_468)
public val Res.string.calendar_sub_file_title: StringResource by lazy {
      StringResource("string:calendar_sub_file_title", "calendar_sub_file_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51457, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 71617, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44780, 67),
      ))
    }

@delegate:ResourceContentHash(-1_474_521_318)
public val Res.string.calendar_sub_intro: StringResource by lazy {
      StringResource("string:calendar_sub_intro", "calendar_sub_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51529, 454),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 71705, 714),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44848, 382),
      ))
    }

@delegate:ResourceContentHash(-329_069_109)
public val Res.string.calendar_sub_link_elsewhere: StringResource by lazy {
      StringResource("string:calendar_sub_link_elsewhere", "calendar_sub_link_elsewhere", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 51984, 267),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 72420, 431),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45231, 251),
      ))
    }

@delegate:ResourceContentHash(1_709_322_987)
public val Res.string.calendar_sub_link_none: StringResource by lazy {
      StringResource("string:calendar_sub_link_none", "calendar_sub_link_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 52252, 126),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 72852, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45483, 114),
      ))
    }

@delegate:ResourceContentHash(-1_183_459_191)
public val Res.string.calendar_sub_link_on: StringResource by lazy {
      StringResource("string:calendar_sub_link_on", "calendar_sub_link_on", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 52444, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 73132, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45655, 72),
      ))
    }

@delegate:ResourceContentHash(-1_164_405_260)
public val Res.string.calendar_sub_link_on_undated: StringResource by lazy {
      StringResource("string:calendar_sub_link_on_undated", "calendar_sub_link_on_undated", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 52379, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 73043, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45598, 56),
      ))
    }

@delegate:ResourceContentHash(578_359_681)
public val Res.string.calendar_sub_manage: StringResource by lazy {
      StringResource("string:calendar_sub_manage", "calendar_sub_manage", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 52501, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 73209, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45728, 39),
      ))
    }

@delegate:ResourceContentHash(-1_927_508_880)
public val Res.string.calendar_sub_new_text: StringResource by lazy {
      StringResource("string:calendar_sub_new_text", "calendar_sub_new_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 52545, 225),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 73273, 373),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45768, 201),
      ))
    }

@delegate:ResourceContentHash(868_158_897)
public val Res.string.calendar_sub_new_title: StringResource by lazy {
      StringResource("string:calendar_sub_new_title", "calendar_sub_new_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 52771, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 73647, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45970, 54),
      ))
    }

@delegate:ResourceContentHash(1_325_606_790)
public val Res.string.calendar_sub_off_text: StringResource by lazy {
      StringResource("string:calendar_sub_off_text", "calendar_sub_off_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 52830, 217),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 73738, 305),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46025, 173),
      ))
    }

@delegate:ResourceContentHash(2_108_600_294)
public val Res.string.calendar_sub_off_title: StringResource by lazy {
      StringResource("string:calendar_sub_off_title", "calendar_sub_off_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53048, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 74044, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46199, 54),
      ))
    }

@delegate:ResourceContentHash(1_733_604_381)
public val Res.string.calendar_sub_pick: StringResource by lazy {
      StringResource("string:calendar_sub_pick", "calendar_sub_pick", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53103, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 74123, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46254, 53),
      ))
    }

@delegate:ResourceContentHash(981_601_680)
public val Res.string.calendar_sub_privacy: StringResource by lazy {
      StringResource("string:calendar_sub_privacy", "calendar_sub_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53161, 304),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 74197, 448),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46308, 276),
      ))
    }

@delegate:ResourceContentHash(-880_665_478)
public val Res.string.calendar_sub_qr: StringResource by lazy {
      StringResource("string:calendar_sub_qr", "calendar_sub_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53599, 211),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 74831, 291),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46706, 199),
      ))
    }

@delegate:ResourceContentHash(-1_550_363_124)
public val Res.string.calendar_sub_qr_description: StringResource by lazy {
      StringResource("string:calendar_sub_qr_description", "calendar_sub_qr_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53466, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 74646, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46585, 75),
      ))
    }

@delegate:ResourceContentHash(762_615_067)
public val Res.string.calendar_sub_qr_show: StringResource by lazy {
      StringResource("string:calendar_sub_qr_show", "calendar_sub_qr_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53550, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 74766, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46661, 44),
      ))
    }

@delegate:ResourceContentHash(-1_848_744_068)
public val Res.string.calendar_sub_title: StringResource by lazy {
      StringResource("string:calendar_sub_title", "calendar_sub_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53811, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75123, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46906, 66),
      ))
    }

@delegate:ResourceContentHash(738_411_215)
public val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53874, 22),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75206, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46973, 22),
      ))
    }

@delegate:ResourceContentHash(348_991_485)
public val Res.string.capacity_answer_no_app: StringResource by lazy {
      StringResource("string:capacity_answer_no_app", "capacity_answer_no_app", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53897, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75245, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46996, 58),
      ))
    }

@delegate:ResourceContentHash(-1_177_254_459)
public val Res.string.capacity_answer_none: StringResource by lazy {
      StringResource("string:capacity_answer_none", "capacity_answer_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 53972, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75356, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47055, 44),
      ))
    }

@delegate:ResourceContentHash(-1_151_197_196)
public val Res.string.capacity_answer_reminded: StringResource by lazy {
      StringResource("string:capacity_answer_reminded", "capacity_answer_reminded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54017, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75409, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47100, 44),
      ))
    }

@delegate:ResourceContentHash(1_712_354_447)
public val Res.string.capacity_answer_sent: StringResource by lazy {
      StringResource("string:capacity_answer_sent", "capacity_answer_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54136, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75576, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47203, 36),
      ))
    }

@delegate:ResourceContentHash(1_219_880_143)
public val Res.string.capacity_answer_sent_by_email: StringResource by lazy {
      StringResource("string:capacity_answer_sent_by_email", "capacity_answer_sent_by_email", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54066, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75466, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47145, 57),
      ))
    }

@delegate:ResourceContentHash(1_945_906_982)
public val Res.string.capacity_answer_started: StringResource by lazy {
      StringResource("string:capacity_answer_started", "capacity_answer_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54181, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75629, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47240, 55),
      ))
    }

@delegate:ResourceContentHash(750_434_664)
public val Res.string.capacity_apply: StringResource by lazy {
      StringResource("string:capacity_apply", "capacity_apply", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54241, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75713, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47296, 30),
      ))
    }

@delegate:ResourceContentHash(-581_303_972)
public val Res.string.capacity_available: StringResource by lazy {
      StringResource("string:capacity_available", "capacity_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54517, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76113, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47568, 38),
      ))
    }

@delegate:ResourceContentHash(1_880_398_572)
public val Res.string.capacity_available_detail: StringResource by lazy {
      StringResource("string:capacity_available_detail", "capacity_available_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54435, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75995, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47478, 89),
      ))
    }

@delegate:ResourceContentHash(-1_676_426_496)
public val Res.string.capacity_available_detail_no_contracts: StringResource by lazy {
      StringResource("string:capacity_available_detail_no_contracts", "capacity_available_detail_no_contracts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54276, 158),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 75768, 226),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47327, 150),
      ))
    }

@delegate:ResourceContentHash(-1_457_330_715)
public val Res.string.capacity_choose_days: StringResource by lazy {
      StringResource("string:capacity_choose_days", "capacity_choose_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54674, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76330, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47717, 44),
      ))
    }

@delegate:ResourceContentHash(-1_118_610_816)
public val Res.string.capacity_choose_days_text: StringResource by lazy {
      StringResource("string:capacity_choose_days_text", "capacity_choose_days_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54556, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76164, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47607, 109),
      ))
    }

@delegate:ResourceContentHash(-749_063_526)
public val Res.string.capacity_col_answer: StringResource by lazy {
      StringResource("string:capacity_col_answer", "capacity_col_answer", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54719, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76387, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47762, 43),
      ))
    }

@delegate:ResourceContentHash(-581_303_972)
public val Res.string.capacity_col_available: StringResource by lazy {
      StringResource("string:capacity_col_available", "capacity_col_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54771, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76447, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47806, 42),
      ))
    }

@delegate:ResourceContentHash(608_521_990)
public val Res.string.capacity_col_person: StringResource by lazy {
      StringResource("string:capacity_col_person", "capacity_col_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54814, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76502, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47849, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("bulk_edit_selected", Res.string.bulk_edit_selected)
  map.put("bulk_edit_title", Res.string.bulk_edit_title)
  map.put("bulk_edit_undone", Res.string.bulk_edit_undone)
  map.put("bulk_effective_from", Res.string.bulk_effective_from)
  map.put("bulk_effective_hint", Res.string.bulk_effective_hint)
  map.put("bulk_end_on", Res.string.bulk_end_on)
  map.put("bulk_field_contract", Res.string.bulk_field_contract)
  map.put("bulk_field_end", Res.string.bulk_field_end)
  map.put("bulk_field_pay", Res.string.bulk_field_pay)
  map.put("bulk_field_role", Res.string.bulk_field_role)
  map.put("bulk_field_skills", Res.string.bulk_field_skills)
  map.put("bulk_finances_only", Res.string.bulk_finances_only)
  map.put("bulk_hours_value", Res.string.bulk_hours_value)
  map.put("bulk_none", Res.string.bulk_none)
  map.put("bulk_pay_amount", Res.string.bulk_pay_amount)
  map.put("bulk_pay_hourly", Res.string.bulk_pay_hourly)
  map.put("bulk_pay_monthly", Res.string.bulk_pay_monthly)
  map.put("bulk_pay_percent", Res.string.bulk_pay_percent)
  map.put("bulk_pay_value", Res.string.bulk_pay_value)
  map.put("bulk_pay_value_hint", Res.string.bulk_pay_value_hint)
  map.put("bulk_problem_contract", Res.string.bulk_problem_contract)
  map.put("bulk_problem_date", Res.string.bulk_problem_date)
  map.put("bulk_problem_nothing", Res.string.bulk_problem_nothing)
  map.put("bulk_problem_pay", Res.string.bulk_problem_pay)
  map.put("bulk_problem_role", Res.string.bulk_problem_role)
  map.put("bulk_problem_skills", Res.string.bulk_problem_skills)
  map.put("bulk_save", Res.string.bulk_save)
  map.put("bulk_scope_group", Res.string.bulk_scope_group)
  map.put("bulk_scope_workplace", Res.string.bulk_scope_workplace)
  map.put("bulk_select", Res.string.bulk_select)
  map.put("bulk_select_all", Res.string.bulk_select_all)
  map.put("bulk_select_hint", Res.string.bulk_select_hint)
  map.put("bulk_select_stop", Res.string.bulk_select_stop)
  map.put("bulk_selected_count", Res.string.bulk_selected_count)
  map.put("bulk_show_summary", Res.string.bulk_show_summary)
  map.put("bulk_skills_add", Res.string.bulk_skills_add)
  map.put("bulk_skills_remove", Res.string.bulk_skills_remove)
  map.put("bulk_skip_already_ended", Res.string.bulk_skip_already_ended)
  map.put("bulk_skip_before_start", Res.string.bulk_skip_before_start)
  map.put("bulk_skip_line", Res.string.bulk_skip_line)
  map.put("bulk_skip_month_closed", Res.string.bulk_skip_month_closed)
  map.put("bulk_skip_no_change", Res.string.bulk_skip_no_change)
  map.put("bulk_skip_no_pay_terms", Res.string.bulk_skip_no_pay_terms)
  map.put("bulk_skip_not_allowed", Res.string.bulk_skip_not_allowed)
  map.put("bulk_summary_count", Res.string.bulk_summary_count)
  map.put("bulk_summary_nothing", Res.string.bulk_summary_nothing)
  map.put("bulk_summary_title", Res.string.bulk_summary_title)
  map.put("bulk_undo", Res.string.bulk_undo)
  map.put("business_month_note", Res.string.business_month_note)
  map.put("business_month_shared", Res.string.business_month_shared)
  map.put("business_month_title", Res.string.business_month_title)
  map.put("busy_elsewhere_other_employer", Res.string.busy_elsewhere_other_employer)
  map.put("busy_elsewhere_rest_note", Res.string.busy_elsewhere_rest_note)
  map.put("busy_elsewhere_same_owner", Res.string.busy_elsewhere_same_owner)
  map.put("calendar_app_apple", Res.string.calendar_app_apple)
  map.put("calendar_app_apple_hint", Res.string.calendar_app_apple_hint)
  map.put("calendar_app_google", Res.string.calendar_app_google)
  map.put("calendar_app_google_hint", Res.string.calendar_app_google_hint)
  map.put("calendar_app_outlook", Res.string.calendar_app_outlook)
  map.put("calendar_app_outlook_hint", Res.string.calendar_app_outlook_hint)
  map.put("calendar_app_outlook_work", Res.string.calendar_app_outlook_work)
  map.put("calendar_app_outlook_work_hint", Res.string.calendar_app_outlook_work_hint)
  map.put("calendar_link_copied", Res.string.calendar_link_copied)
  map.put("calendar_link_copy", Res.string.calendar_link_copy)
  map.put("calendar_link_new", Res.string.calendar_link_new)
  map.put("calendar_link_off", Res.string.calendar_link_off)
  map.put("calendar_sub_copy_hint", Res.string.calendar_sub_copy_hint)
  map.put("calendar_sub_file_title", Res.string.calendar_sub_file_title)
  map.put("calendar_sub_intro", Res.string.calendar_sub_intro)
  map.put("calendar_sub_link_elsewhere", Res.string.calendar_sub_link_elsewhere)
  map.put("calendar_sub_link_none", Res.string.calendar_sub_link_none)
  map.put("calendar_sub_link_on", Res.string.calendar_sub_link_on)
  map.put("calendar_sub_link_on_undated", Res.string.calendar_sub_link_on_undated)
  map.put("calendar_sub_manage", Res.string.calendar_sub_manage)
  map.put("calendar_sub_new_text", Res.string.calendar_sub_new_text)
  map.put("calendar_sub_new_title", Res.string.calendar_sub_new_title)
  map.put("calendar_sub_off_text", Res.string.calendar_sub_off_text)
  map.put("calendar_sub_off_title", Res.string.calendar_sub_off_title)
  map.put("calendar_sub_pick", Res.string.calendar_sub_pick)
  map.put("calendar_sub_privacy", Res.string.calendar_sub_privacy)
  map.put("calendar_sub_qr", Res.string.calendar_sub_qr)
  map.put("calendar_sub_qr_description", Res.string.calendar_sub_qr_description)
  map.put("calendar_sub_qr_show", Res.string.calendar_sub_qr_show)
  map.put("calendar_sub_title", Res.string.calendar_sub_title)
  map.put("cancel", Res.string.cancel)
  map.put("capacity_answer_no_app", Res.string.capacity_answer_no_app)
  map.put("capacity_answer_none", Res.string.capacity_answer_none)
  map.put("capacity_answer_reminded", Res.string.capacity_answer_reminded)
  map.put("capacity_answer_sent", Res.string.capacity_answer_sent)
  map.put("capacity_answer_sent_by_email", Res.string.capacity_answer_sent_by_email)
  map.put("capacity_answer_started", Res.string.capacity_answer_started)
  map.put("capacity_apply", Res.string.capacity_apply)
  map.put("capacity_available", Res.string.capacity_available)
  map.put("capacity_available_detail", Res.string.capacity_available_detail)
  map.put("capacity_available_detail_no_contracts", Res.string.capacity_available_detail_no_contracts)
  map.put("capacity_choose_days", Res.string.capacity_choose_days)
  map.put("capacity_choose_days_text", Res.string.capacity_choose_days_text)
  map.put("capacity_col_answer", Res.string.capacity_col_answer)
  map.put("capacity_col_available", Res.string.capacity_col_available)
  map.put("capacity_col_person", Res.string.capacity_col_person)
}
